module.exports = __webpack_public_path__ + "img/宋鲁增@2x.56064c95.png";